import cx from "clsx";
import { Collection } from "kreate-common/modules/business-types";
import CircularProgress$Indeterminate from "kreate-common/modules/kreate-ui/components/CircularProgress/components/CircularProgress$Indeterminate";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";

import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";
import { getLinkToPageCollection } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: Collection | null | undefined;
  fill: true;
};

export default function CardCollection({
  className,
  style,
  collection,
}: Props) {
  if (!collection) {
    return (
      <div className={cx(styles.container, className)} style={style}>
        <Flex.Row alignItems="center" justifyContent="center" padding="96px">
          <CircularProgress$Indeterminate size="96px" />
        </Flex.Row>
      </div>
    );
  }

  return (
    <div className={cx(styles.container, className)} style={style}>
      <Link href={getLinkToPageCollection(collection)}>
        <div className={styles.bannerContainer}>
          <ImageViewer value={collection.banner} sizing="fill" sizes="560px" />
        </div>
      </Link>
      <div className={styles.avatarPositionHolder}>
        <Link href={getLinkToPageCollection(collection)}>
          {collection.avatar ? (
            <div className={styles.avatarContainer}>
              <ImageViewer
                value={collection.avatar}
                sizing="fill"
                sizes="56px"
              />
            </div>
          ) : null}
        </Link>
      </div>
      <Flex.Col
        padding="36px 24px 24px 24px"
        justifyContent="center"
        gap="12px"
      >
        <div className={styles.title}>
          <Link href={getLinkToPageCollection(collection)}>
            {collection.title || EM_DASH}
          </Link>
        </div>
        <div className={styles.numTotalArtworks}>
          <strong>{collection.numArtworks ?? EM_DASH}</strong>
          <span>{" Artworks"}</span>
        </div>
      </Flex.Col>
    </div>
  );
}
